import React from "react";
import { observable, action } from "mobx";
import * as Api from "api";
import * as User from "api/User";

interface Value {
  loginId?: string;
  password?: string;
}

export class Store {
  public errors = new Api.Error<User.AccessTokenParams>();

  @observable.ref
  public loading = false;

  @observable
  public value: Value = {};

  @action.bound
  public async accessToken() {
    this.loading = true;
    this.errors.clear();

    const response = await User.Api.accessToken(this.value);
    this.loading = false;

    if (!response) return "";

    if (response.status === Api.Status.OK) {
      return response.data.accessToken;
    }

    this.errors.set(response.data);

    return "";
  }
}

const Context = React.createContext<Store | null>(null);

export const StoreProvider: React.FC<{ value?: Store }> = ({
  children,
  value,
}) => {
  const store = React.useMemo(() => (value ? value : new Store()), [value]);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useStore = () => {
  const store = React.useContext(Context);
  if (!store) {
    throw new Error("useStore must be used within a StoreProvider.");
  }
  return store;
};
